/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { syncProductHasVariants } from './helpers/productVariantsHelpers';

export const createOptionValue = createAsyncThunk(
  'products/createOptionValue',
  async ({ productId, optionName, name }, {
    extra: { Logger, Toast, sdk },
    getState,
  }) => {
    try {
      const product = getState().products.items.find(({ _id }) => _id === productId);
      const option = product?.availableOptions?.find(({ name: n }) => n === optionName);

      if (!option?.name) {
        throw new Error('Option not found');
      }

      const values = [...(option.values || []).map((value) => value?.name ?? value), name];
      const { data } = await sdk.products.updateOption(productId, {
        name: option.name,
        values,
      });
      return data;
    } catch (error) {
      Toast(
        'Option value is not created. Refresh and try again',
        { autoClose: false, type: 'error' },
      );
      Logger.error(new Error('Error option value creating'), { error }, [
        'CreateOptionValueFailed',
        { errorMessage: 'Option value is not created on the backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    createOptionValue.pending,
    (state, { meta }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = true;
        }
      });
    },
  ).addCase(
    createOptionValue.fulfilled,
    (state, { payload, meta }) => {
      const { productId, optionName } = meta.arg;
      state.items = state.items.map((product) => {
        if (product._id === productId) {
          const updatedProduct = {
            ...product,
            isBusy: false,
            variants: payload.variants,
            availableOptions: payload.availableOptions ?? (product.availableOptions || []).map((opt) => (
              opt.name === optionName ? { ...opt, values: payload.option.values } : opt
            )),
            hasVariants: payload.hasVariants ?? product.hasVariants,
          };
          if (payload.hasVariants == null) {
            syncProductHasVariants(updatedProduct);
          }
          return updatedProduct;
        }
        return product;
      });
    },
  ).addCase(
    createOptionValue.rejected,
    (state, { meta, error }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = false;
        }
      });
      state.error = error;
    },
  );
};
